var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnlockedLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4 0a4 4 0 0 0-4 4h2a2 2 0 1 1 4 0v2l-.141.005A2 2 0 0 0 4 8v6c0 1.105.902 2 2.009 2h7.982A2 2 0 0 0 16 14V8c0-1.105-.902-2-2.009-2H8V4l-.005-.2A4 4 0 0 0 4 0m5 10h2v2H9z"
})));
export default SvgUnlockedLeft;